function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { IrisGridModel } from '@deephaven/iris-grid';
import ConnectedIrisGridPanel from "./IrisGridPanel.js";
import { PandasReloadButton } from "./PandasReloadButton.js";
import "./PandasPanel.css";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Wraps and IrisGridPanel to add a refresh button for Pandas.
 */
class PandasPanel extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/sort-comp
    _defineProperty(this, "irisGridRef", void 0);
    _defineProperty(this, "model", null);
    this.irisGridRef = /*#__PURE__*/React.createRef();
    this.handleDisconnect = this.handleDisconnect.bind(this);
    this.handleReload = this.handleReload.bind(this);
    this.handleGridStateChange = this.handleGridStateChange.bind(this);
    this.handlePanelStateUpdate = this.handlePanelStateUpdate.bind(this);
    var panelState = props.panelState;
    this.state = {
      shouldFocusGrid: false,
      panelState,
      // Dehydrated panel state that can load this panel
      makeModel: this.wrapMakeModel(props.makeModel)
    };
  }
  componentDidUpdate(prevProps) {
    var prevMakeModel = prevProps.makeModel;
    var makeModel = this.props.makeModel;
    if (prevMakeModel !== makeModel) {
      this.setState({
        makeModel: this.wrapMakeModel(makeModel)
      });
    }
  }
  componentWillUnmount() {
    if (this.model != null) {
      this.stopListening(this.model);
    }
  }
  wrapMakeModel(makeModel) {
    var _this = this;
    return /*#__PURE__*/_asyncToGenerator(function* () {
      // Need to listen for disconnect in the model, so we know when to throw this makeModel away
      var model = yield makeModel();
      if (_this.model != null) {
        _this.stopListening(_this.model);
      }
      _this.model = model;
      _this.startListening(model);
      return model;
    });
  }
  startListening(model) {
    model.addEventListener(IrisGridModel.EVENT.DISCONNECT, this.handleDisconnect);
  }
  stopListening(model) {
    model.removeEventListener(IrisGridModel.EVENT.DISCONNECT, this.handleDisconnect);
  }
  handleDisconnect() {
    var _this$irisGridRef$cur;
    // Once a Pandas widget is closed, the underlying table is closed and cannot be reconnected to.
    // Reset the model to undefined so IrisGridPanel doesn't try to use it anymore.
    (_this$irisGridRef$cur = this.irisGridRef.current) === null || _this$irisGridRef$cur === void 0 || _this$irisGridRef$cur.setState({
      model: undefined
    });
  }
  handleReload() {
    var _this$irisGridRef$cur2;
    (_this$irisGridRef$cur2 = this.irisGridRef.current) === null || _this$irisGridRef$cur2 === void 0 || _this$irisGridRef$cur2.initModel();
    this.setState({
      shouldFocusGrid: true
    });
  }
  handleGridStateChange() {
    var _this$irisGridRef$cur3;
    var shouldFocusGrid = this.state.shouldFocusGrid;
    if (shouldFocusGrid && (_this$irisGridRef$cur3 = this.irisGridRef.current) !== null && _this$irisGridRef$cur3 !== void 0 && (_this$irisGridRef$cur3 = _this$irisGridRef$cur3.irisGrid) !== null && _this$irisGridRef$cur3 !== void 0 && (_this$irisGridRef$cur3 = _this$irisGridRef$cur3.current) !== null && _this$irisGridRef$cur3 !== void 0 && _this$irisGridRef$cur3.grid) {
      this.irisGridRef.current.irisGrid.current.grid.focus();
      this.setState({
        shouldFocusGrid: false
      });
    }
  }
  handlePanelStateUpdate(panelState) {
    this.setState({
      panelState
    });
  }
  render() {
    var makeModel = this.state.makeModel;
    return /*#__PURE__*/_jsx(ConnectedIrisGridPanel, _objectSpread(_objectSpread({
      ref: this.irisGridRef,
      onStateChange: this.handleGridStateChange,
      onPanelStateUpdate: this.handlePanelStateUpdate
    }, this.props), {}, {
      makeModel: makeModel,
      children: /*#__PURE__*/_jsx(PandasReloadButton, {
        onClick: this.handleReload
      })
    }));
  }
}
_defineProperty(PandasPanel, "defaultProps", {
  panelState: null
});
_defineProperty(PandasPanel, "COMPONENT", 'PandasPanel');
export default PandasPanel;
//# sourceMappingURL=PandasPanel.js.map